import Badge from "react-bootstrap/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "preact-router";
import ToolkitProvider, { CSVExport, Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from 'react-bootstrap-table2-paginator';
import BootstrapTable from 'react-bootstrap-table-next';
import { faEye, faTrash, faPen } from "@fortawesome/free-solid-svg-icons";
import { formatDateFr } from "../../lib/utils";
import { deleteField } from "../../api/fields";
import { route } from "preact-router";
import { Button } from "react-bootstrap";
import { deleteProductField } from "../../api/products";

export default function FieldTable({
    fields,
    onFieldDelete,
    product,
    ...props
}) {


    const onDelete = (e, id) => {

        e.stopPropagation();
        e.preventDefault();

        const deleteFunction = product ? deleteProductField(product.code, id) : deleteField(id);

        if (confirm('Voulez-vous vraiment supprimer ce champ ?')) {
            deleteFunction.then(() => {
                if (onFieldDelete) {
                    onFieldDelete(id);
                }
            }).catch((ex) => {
                alert('Une erreur est survenue lors de la suppression du champ : ' + JSON.stringify(ex));
            });
        }
    }

    const columns = [
        {
            dataField: "key",
            text: "Clef",
            sort: true,
            formatter: (cell, row) => {
                return <code>{cell}</code>
            }
        },
        {
            dataField: "type",
            text: "Type",
            sort: true,
            formatter: (cell, row) => {
                return <Badge variant="primary">{cell}</Badge>
            },
        },
        {
            dataField: "label",
            text: "Libellé",
            sort: true,
            formatter: (cell, row) => {
                return cell;
            },
        },
        {
            dataField: "field_group_key",
            text: "Groupe",
            sort: true,
            formatter: (cell, row) => {
                return cell ? <Link href={`/save-field-group/${row.field_group_key}`}>{cell}</Link> : "Aucun";
            }
        },
        {
            dataField: "position",
            text: "Position",
            sort: true,
            formatter: (cell, row) => {
                return <code>{cell}</code>
            }
        },
        {
            dataField: "created_at",
            text: "Créé à",
            sort: true,
            formatter: (cell, row) => {
                return formatDateFr(cell);
            }
        },
        {
            dataField: "actions",
            required: false,
            text: "Actions",
            isDummyField: true,
            formatter: (cell, row) => {
                return (
                    <div class="btn-group">
                        <Link href={`/save-field/${row.key}/${product ? product.code : ""}`} className="btn btn-sm btn-primary">
                            <FontAwesomeIcon icon={faPen} />
                        </Link>
                        <button onClick={(e) => onDelete(e, row.key)} className="btn btn-sm btn-danger">
                            <FontAwesomeIcon icon={faTrash} />
                        </button>
                    </div>
                );
            },
        }
    ];

    const rowEvents = {
        onClick: (e, row, rowIndex) => {
            return route(`/save-field/${row.key}/${product ? product.code : ""}`);
        }
    }

    return (
        <>
            <ToolkitProvider
                search={true}
                keyField="key"
                data={fields}
                columns={columns}
                pagination={paginationFactory({
                    hideSizePerPage: true,
                    totalSize: fields?.length,
                    sizePerPage: fields?.length,
                })}
                exportCSV>
                {(props) => (
                    <>
                        <div className="border-bottom">
                            <Search.SearchBar
                                {...props.searchProps}
                                className="form-control border-0"
                                placeholder="Rechercher..."
                                style={{ width: '100%' }}

                            />
                        </div>
                        <BootstrapTable
                            rowStyle={{
                                cursor: 'pointer'
                            }}
                            rowClasses={(row, rowIndex) => {
                                return 'cursor-pointer animate__animated animate__fadeIn';
                            }}
                            rowEvents={rowEvents}
                            classes={"align-middle"}
                            bordered={false}
                            striped
                            hover
                            {...props.baseProps}
                        />
                    </>
                )}
            </ToolkitProvider>
        </>
    );

}